module.exports = __webpack_public_path__ + "static/media/OralMedicineRadiologyMDS.f146a5f2.docx";